<!-- 登录 -->
<template>
  <div>
    <el-dialog
      :visible.sync="value"
      title="用户角色信息"
      width="550px"
      :show-close="true"
      :close-on-click-modal="false"
      @open="handleOpenDailog"
      @close="resetForm('ruleForm')"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        status-icon
        :rules="rules"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item
          label-width="0"
          prop="selectedIdentity"
        >
          <el-select
            v-model="ruleForm.selectedIdentity"
            style="width:100%"
            placeholder="请选择用户角色"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="flex">
          <el-row
            type="flex"
            class="row-bg"
            justify="space-between"
          >
            <el-col :span="11">
              <el-button
                class="w100"
                type="primary"
                @click="submitForm('ruleForm')"
              >
                提交
              </el-button>
            </el-col>
            <el-col :span="11">
              <el-button
                class="w100"
                @click="resetForm('ruleForm')"
              >
                取消
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import pathReq from '../../api/pathlist'

export default {
  props: {
    value: { type: Boolean, default: false },
    selVal: { type: Number, default: null }
  },
  data() {
    return {
      options: [],
      ruleForm: {
        selectedIdentity: '',
        tenancyName: '',
        usernameOrEmailAddress: '',
        password: '',
        rememberMe: true
      },

      rules: {
        selectedIdentity: [
          { required: true, message: '请选择角色', trigger: 'submitForm' }
        ]
      }
    }
  },
  created() {
    this.$bus.off('show/role')
    this.$bus.on('show/role', this.getRole)
  },

  methods: {
    handleOpenDailog() {
      this.getRole()
      this.ruleForm.selectedIdentity = this.selVal.toString()
    },
    handleClose() {
      this.$emit('input', false)
    },
    /**
     * 获取角色
     */
    getRole() {
      const token = localStorage.getItem('accessToken')
      const that = this
      const path = '/api/services/app/EndUserUnitMember/GetCurrentUserIdentityList'

      if (token) {
        pathReq.getNoParams(path).then((res) => {
          if (res.status === 200) {
            if (res.data.success) {
              that.$data.options = res.data.result
            }
          }
        })
      }
    },

    submitForm(formName) {
      const that = this
      // var oldPath = this.$route.path;
      this.$refs[formName].validate(valid => {
        if (valid) {
          // const path = '/api/services/app/EndUserUnitMember/SetCurrentUserSelectIdentity'
          const path = 'api/TokenAuth/AuthenticateWithIdentity'

          that.ruleForm.usernameOrEmailAddress = localStorage.getItem('userName')
          that.ruleForm.password = localStorage.getItem('userPsd')
          that.ruleForm.rememberMe = true

          pathReq.postForm(path, that.ruleForm).then(res => {
            if (res.status === 200) {
              if (res.data.success) {
                this.$bus.emit('reloadShow')

                const accessToken = res.data.result.accessToken
                localStorage.setItem('isLogin', true)
                localStorage.setItem('accessToken', accessToken)
                localStorage.setItem('UserSelectedIdentity', that.ruleForm.selectedIdentity)

                const path2 = '/api/services/app/EndUserUnitMember/SetCurrentUserSelectIdentity'
                pathReq.postForm(path2, { selectedIdentity: that.ruleForm.selectedIdentity }).then(_ => {
                  that.$router.go(0)
                })
              }
            }
          }).then(_ => {
            this.$emit('input', false)
            this.$emit('success')
            // success
          })
        } else {
          return false
        }
      })
    },
    // 取消
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$emit('input', false)
    },
    /** 关闭 */
    handleBeforeClose() {
      this.$refs.ruleForm.resetFields()
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.w40 {
  width: 40%;
}

.w100 {
  width: 100%;
}

/* .ipth60 {
  height: 60px;
} */

.el-input__inner {
  height: 100%;
}
</style>
